import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export enum PanelHeaderTitle {
	PlanogramConfiguration = 'TITLE_CONFIG_BRANDS',
	EquipmentConfiguration = 'INSTRUMENT_CONFIG',
	ProductLabels = 'PRODUCT_LABELS',
	AutoLayout = 'AUTOLAYOUT_PANEL_TITLE',
	ProductLayout = 'PRODUCT_LAYOUT_CONF',
	MasterPositionLayout = 'MASTER_POSITION.LAYOUT_SETTINGS',
	LayoutSettings = 'COMMON.LAYOUT_SETTINGS',
	LayoutRules = 'RULES.FOLDERS.TITLE',
	Block = 'BLOCK_CONF',
	BrandStats = 'BRANDS_STATISTICS',
	CategoryStats = 'CATEGORIES_STATS',
	EquipmentInfo = 'EQUIPMENT_EDIT.SETTINGS_TITLE',
	ReportSettings = 'COMMON.REPORT_SETTINGS',
	LayoutHistory = 'LAYOUT_HISTORY',
	ProductsHighlights = 'DEMO.BLOCKED_FUNCTIONAL.TITLES.PRODUCTS_HIGHLIGHTS',
	Filters = 'FILTERS',
	Settings = 'COMMON.SETTINGS',
	PersonalSettings = 'PERSONAL_SETTINGS.TITLE',
	POSMaterials = 'COMMON.PLANOGRAM.POS_TITLE',
	POSImageMaterialsConfig = 'COMMON.PLANOGRAM.POS_IMAGE_CONFIG',
	TextSettings = 'TEXT_SETTINGS',
	Notifications = 'NOTIFICATIONS.TITLE',
	BackImageConfig = 'COMMON.PLAN.BACK_IMAGE_CONFIG'
}

export interface IPanelTitleOptions {
	value: any;
	translate: string;
	checked: boolean;
}

export const DEFAULT_PANEL_WIDTH_PX: number = 500;

@Injectable()
export class SidePanelService {
	cancelClose: boolean = true;
	disabledApply: boolean = false;
	hasBackdrop: boolean = false;
	backdropShadow: boolean = false;
	mustSaveModal: boolean = false;
	panelWidth: number = DEFAULT_PANEL_WIDTH_PX;
	showButtons: boolean = true;
	title: string;
	titleOptions: Array<IPanelTitleOptions> = null;

	applySubject: Subject<void> = new Subject<void>();
	cancelSubject: Subject<void> = new Subject<void>();
	closeSubject: Subject<void> = new Subject<void>();
	titleSelectSubject: Subject<any> = new Subject<any>();

	constructor() {}
}
